export const ASK_HAPTIK_LINKS = [
  {
    url:
      'http://ask.hellohaptik.com/question/3/what-is-the-difference-between-a-story-and-substory-in-a-bot/',
    title: 'What is a Story/SubStory in a Bot?',
  },
  {
    url:
      'http://ask.hellohaptik.com/question/95/how-to-get-web-sdk-link-for-bot/',
    title: 'How to get Web SDK link for bot?',
  },
  {
    url:
      'http://ask.hellohaptik.com/question/22/how-do-i-block-unblock-a-bot-transfer/',
    title: 'How do I Block/Unblock a transfer',
  },
  {
    url: 'http://ask.hellohaptik.com/question/11/what-is-a-context-flag/',
    title: 'What is a Context flag?',
  },
];
